import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')

const ROUTE_NAME = 'profile:payment:'

const p = name => ROUTE_NAME + name

const LIST = p('list')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([
          'parent', 'company', 'child', 'employee',
          'student', 'teacher',
        ], options),
      },
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
